import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend'; // Import HTTP backend

// Define the direction for each language
const directionMap = {
  en: 'ltr',
  ar: 'rtl',
};

// Initialize i18n with resources and settings
i18n
  .use(HttpApi) // Use HTTP backend to load translation files
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'ar', // Set default language to Arabic
    fallbackLng: 'en', // Fallback to English if Arabic is not available
    debug: false, // Set to true for debugging in development
    interpolation: {
      escapeValue: false, // Not needed for React as it handles escaping
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      loadPath: '/Geoportal/locales/{{lng}}.json', // Path to load translation files
    },
  });

// Change the `dir` and `lang` attributes on the <html> tag based on the current language
i18n.on('languageChanged', (lng) => {
  const direction = directionMap[lng] || 'ltr';
  document.documentElement.setAttribute('dir', direction);
  document.documentElement.setAttribute('lang', lng);
});

// Set the default direction to 'rtl' when Arabic is the default language
const defaultLang = i18n.language || window.navigator.language;
const initialDirection = directionMap[defaultLang] || 'ltr';
document.documentElement.setAttribute('dir', initialDirection);
document.documentElement.setAttribute('lang', defaultLang);

export default i18n;


